import $ from "jquery";
import _escape from "lodash/escape";
import Marionette from "backbone.marionette";

import { MOBILE_BREAK, SUGGESTION_FEATURE } from "lib/constants";

import cTmpl from "../templates/components";
import modelUtil from "../models/util";

export default Marionette.View.extend({
    template: cTmpl.JobCardNew,
    className: "job-card--new js-job-detail js-job-data",
    ui: {
        added: ".job-card__added",
    },
    events: {
        "click .job-card__auto-match-bar": "onAutoMatchModal",
    },
    serializeData() {
        const data = this.model.toJSON();

        const stype = modelUtil.SCHEDULE_TYPE_MAP[data.schedule_type];
        data.schedule_type_text = stype || "";

        if (data.schedule_start && data.schedule_start.match(/\d(am|pm)/i)) {
            data.schedule_start = `${data.schedule_start.toLowerCase()} start time`;
        }

        data.link += "?suggested=1";
        data.approved_text = this.options.approvedText || "Added to application!";
        data.autoMatch = data.suggestion_feature === SUGGESTION_FEATURE.AUTOMATCH;

        let action = window.innerWidth > MOBILE_BREAK ? "Click" : "Tap";
        action = `...<strong>${action} to see details</strong>`;
        data.description = _escape(data.description);
        data.description = `${data.description.substring(0, 200).trim()}${action}`;

        return data;
    },
    onAutoMatchModal(event) {
        event.preventDefault();
        event.stopPropagation();

        $("#auto-match-modal").modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
    },
    onRender() {
        const data = this.serializeData();
        this.$el.data("id", `position-detail-${data.id}`);
        this.$el.data("url", data.link);
        this.$el.data("hide-footer", "true");
        this.$el.data("hide-apply", "true");
    },
    showAdded(callback) {
        this.ui.added.fadeIn(() => {
            setTimeout(callback, 700);
        });
    },
});
